import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { 
  browserTracingIntegration, 
  browserProfilingIntegration, 
  replayIntegration 
} from "@sentry/react";


Sentry.init({
  dsn: "https://ffe669e9e1e9a597b62e4822ed011b95@o4508971558633472.ingest.de.sentry.io/4510844902113360", 
  
  integrations: [
    // Performance Monitoring (replaces BrowserTracing)
    browserTracingIntegration({
      // Optional: Control which URLs get traced
      tracePropagationTargets: ["localhost", /^https:\/\/your-api\.com/],
    }),
    
    // Optional: Browser Profiling for detailed performance data
    browserProfilingIntegration(),
    
    // Optional: Session Replay
    // replayIntegration({
    //   maskAllText: true,
    //   blockAllMedia: true,
    // }),
  ],
  
  // ⚡ PERFORMANCE MONITORING SETTINGS
  tracesSampleRate: 1.0, // Capture 100% of transactions
  
  // Optional: Advanced sampling (v8.x supports this)
  // tracesSampler: (samplingContext) => {
  //   if (samplingContext.transactionContext.name === 'Slow Operation') return 1.0;
  //   return 0.5;
  // },
  
  // 🌐 Environment context
  environment: process.env.NODE_ENV,
  release: `my-app@${process.env.REACT_APP_VERSION || '1.0.0'}`,
  
  // Optional: Profiling sample rate (if using browserProfilingIntegration)
  profilesSampleRate: 1.0,
});


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
